export const errorMessageForCreateUserRequest =
  "Введенный код не соответствует отправленному. Введите правильный код подтверждения";
